import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { setInfoBeneficiar } from 'redux/beneficiarDetail/slice';
import { InputText } from 'ui/InputText';
import { Button } from 'ui/Button';
import { Title } from 'components/Title';
import { WhiteBlock } from 'components/WhiteBlock';
import ModalUpdateCommission from './ModalUpdateCommission';
import styles from './BeneficiariesDetails.module.scss';

interface CastomerCommissionFormProps {
  id: string | undefined;
  modalCommissionOpen: boolean;
  setModalCommissionOpen: (open: boolean) => void;
  refetch: () => void;
}

export default function CastomerCommissionForm({
  id,
  modalCommissionOpen,
  setModalCommissionOpen,
  refetch,
}: CastomerCommissionFormProps) {
  const { infoBeneficiar } = useSelector((state: RootState) => state.beneficiarSlice);
  const dispatch = useDispatch();

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
    dispatch(
      setInfoBeneficiar({
        key: 'commission',
        value: e.target.value,
        step: true,
        secondKey: name,
      }),
    );
  };

  const onBlurHandler = () => {
    // console.log('onBlurHandler', e.target.value, name);
  };

  const openModalUpdateCommissionHandler = () => {
    setModalCommissionOpen(true);
  };

  return (
    <WhiteBlock>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Title title='Комиссия' />
        <Button
          className={styles.button}
          onClick={openModalUpdateCommissionHandler}
          theme='filed'>
          Изменить
        </Button>
        <ModalUpdateCommission
          id={id || ''}
          isOpen={modalCommissionOpen}
          onClose={() => setModalCommissionOpen(false)}
          refetch={refetch}
        />
      </div>
      <div className={styles.inputBlock}>
        <InputText
          beneficiaries
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChangeHandler(e, 'percent')
          }
          onBlurHandler={onBlurHandler}
          value={String(infoBeneficiar?.commission?.percent || 0)}
          placeholder='%'
          isDisabled
        />
        <InputText
          beneficiaries
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChangeHandler(e, 'min_amount')
          }
          onBlurHandler={onBlurHandler}
          value={String(infoBeneficiar?.commission?.min_amount || 0)}
          placeholder='но не менее'
          price='₽'
          isDisabled
        />
      </div>
    </WhiteBlock>
  );
}
